import { FC } from "react";
import { Table, TBody, TD, TH, THead, TR } from "components/table";
import { Separator, Uppgift } from "types/separator/separator.type";
import { AssignmentTypeTag } from "components/AssignmentTypeTag";
import { ActivityType } from "enums/ActivityType.enum";
import { useNavigate } from "@tanstack/react-router";
import { formatDate } from "helpers/date";
import EmptyState from "components/EmptyState";
import {
  ContentContainer,
  HeaderContainer,
  ShadowCard,
} from "components/ShadowCard";
import { Headline4 } from "components/typography/Headline4";
interface Props {
  separator: Separator;
}

export const SeparatorAssignmentsTab: FC<Props> = ({ separator }) => {
  const navigate = useNavigate();
  const navigateToUppgift = (uppgift: Uppgift) => {
    switch (uppgift.type) {
      case ActivityType.SixMonthsInspection: {
        navigate({
          to: "/app/uppdrag/$uuid/sixm/$sixmid",
          params: {
            uuid: uppgift.uppdragUuid,
            sixmid: uppgift.id.toString(),
          },
        });
        break;
      }
      case ActivityType.FiveYearInspection: {
        navigate({
          to: "/app/uppdrag/$uuid/fivey/$fiveyid",
          params: {
            uuid: uppgift.uppdragUuid,
            fiveyid: uppgift.id.toString(),
          },
        });
        break;
      }
      case ActivityType.WaterMeasurementProtocol: {
        navigate({
          to: "/app/uppdrag/$uuid/provtagning/$pid",
          params: {
            uuid: uppgift.uppdragUuid,
            pid: uppgift.id.toString(),
          },
        });
        break;
      }
      case ActivityType.Tomning: {
        navigate({
          to: "/app/uppdrag/$uuid/tomning/$wasteId",
          params: {
            uuid: uppgift.uppdragUuid,
            wasteId: uppgift.tomning!.waste.id.toString(),
          },
        });
        break;
      }
      default:
        throw Error(
          `navigateToUppgift is missing implementation for ${uppgift.type}`,
        );
    }
  };

  return (
    <ShadowCard className="max-w-5xl">
      <HeaderContainer>
        <Headline4>Historik</Headline4>
      </HeaderContainer>
      <ContentContainer>
        {separator.uppgiftList.length === 0 ? (
          <EmptyState
            header="Inga tidigare händelser"
            subHeader="Här samlas händelser så som kontroller och tömningar för objektet. Använd anläggning/uppdrag för att skapa nya."
            iconType="uppdrag"
          />
        ) : (
          <Table>
            <THead>
              <TR>
                <TH isFirstColumn>Typ</TH>
                <TH>Datum</TH>
              </TR>
            </THead>
            <TBody>
              {separator.uppgiftList.map((uppgift: Uppgift) => (
                <TR key={uppgift.id} onClick={() => navigateToUppgift(uppgift)}>
                  <TD isFirstColumn>
                    <AssignmentTypeTag useTomningLabel type={uppgift.type} />
                  </TD>
                  <TD>{formatDate(uppgift.inspectionDate?.toString())}</TD>
                </TR>
              ))}
            </TBody>
          </Table>
        )}
      </ContentContainer>
    </ShadowCard>
  );
};
